// Libraries
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

// Assets
import { ReactComponent as ImagesIcon } from '@assets/icons/pageBlocks/picture.svg';
import { ReactComponent as VideoIcon } from '@assets/icons/pageBlocks/video.svg';
import { ReactComponent as AssetLinkIcon } from '@assets/icons/pageBlocks/plus_button.svg';
import { ReactComponent as AssetCardIcon } from '@assets/icons/pageBlocks/plus_file.svg';
import { ReactComponent as LinkIcon } from '@assets/icons/pageBlocks/link.svg';
import { ReactComponent as FigmaIcon } from '@assets/icons/pageBlocks/code.svg';
import { ReactComponent as ColorsIcon } from '@assets/icons/pageBlocks/color_book.svg';

import { ReactComponent as OneImage } from '@assets/icons/pageBlocks/images/1image.svg';
import { ReactComponent as TwoImages } from '@assets/icons/pageBlocks/images/2images.svg';
import { ReactComponent as ThreeImages } from '@assets/icons/pageBlocks/images/3images.svg';
import { ReactComponent as Carousel } from '@assets/icons/pageBlocks/images/carousel.svg';
import { ReactComponent as Slider } from '@assets/icons/pageBlocks/images/slider.svg';
import { ReactComponent as TwoDoDont } from '@assets/icons/pageBlocks/images/2do&dont.svg';
import { ReactComponent as ThreeDoDont } from '@assets/icons/pageBlocks/images/3do&dont.svg';

import { ReactComponent as HorizontalCard } from '@assets/icons/pageBlocks/cards/horizontal.svg';
import { ReactComponent as VerticalCard } from '@assets/icons/pageBlocks/cards/vertical.svg';

import { ReactComponent as PrimaryColors } from '@assets/icons/pageBlocks/colors/primary_block.svg';
import { ReactComponent as SecondaryColors } from '@assets/icons/pageBlocks/colors/secondary_block.svg';

// Types
import { WIKI_ENTITIES } from '@services/boards/types';

const {
  IMAGE,
  TWO_IMAGES,
  THREE_IMAGES,
  TWO_DO_IMAGES,
  THREE_DO_IMAGES,
  VIDEO,
  SLIDER,
  CAROUSEL,
  HORIZONTAL_CARDS,
  VERTICAL_CARDS,
  ASSET_BUTTON,
  SEPARATED_LINK,
  FIGMA_FRAME,
  PRIMARY_COLORS,
  SECONDARY_COLORS
} = WIKI_ENTITIES;

export default [
  {
    id: uuidv4(),
    title: 'Add images',
    icon: <ImagesIcon />,
    type: 'image',
    subMenu: [
      {
        id: uuidv4(),
        icon: <OneImage />,
        title: '1 image',
        type: IMAGE
      },
      {
        id: uuidv4(),
        icon: <TwoImages />,
        title: '2 images',
        type: TWO_IMAGES
      },
      {
        id: uuidv4(),
        icon: <ThreeImages />,
        title: '3 images',
        type: THREE_IMAGES
      },
      {
        id: uuidv4(),
        icon: <Carousel />,
        title: 'Carousel',
        type: CAROUSEL
      },
      {
        id: uuidv4(),
        icon: <Slider />,
        title: 'Slider',
        type: SLIDER
      },
      {
        id: uuidv4(),
        icon: <TwoDoDont />,
        title: '2 DOs and DON\'Ts',
        type: TWO_DO_IMAGES
      },
      {
        id: uuidv4(),
        icon: <ThreeDoDont />,
        title: '3 DOs and DON\'Ts',
        type: THREE_DO_IMAGES
      }
    ]
  },
  {
    id: uuidv4(),
    title: 'Add video',
    icon: <VideoIcon />,
    type: VIDEO
  },
  {
    id: uuidv4(),
    title: 'Add asset button',
    icon: <AssetLinkIcon />,
    type: ASSET_BUTTON
  },
  {
    id: uuidv4(),
    title: 'Add asset card',
    icon: <AssetCardIcon />,
    type: 'asset-card',
    subMenu: [
      {
        id: uuidv4(),
        icon: <HorizontalCard />,
        title: 'Horizontal card',
        type: HORIZONTAL_CARDS
      },
      {
        id: uuidv4(),
        icon: <VerticalCard />,
        title: 'Vertical cards',
        type: VERTICAL_CARDS
      }
    ]
  },
  {
    id: uuidv4(),
    title: 'Add separate link',
    icon: <LinkIcon />,
    type: SEPARATED_LINK
  },
  {
    id: uuidv4(),
    title: 'Add figma frame embed',
    icon: <FigmaIcon />,
    type: FIGMA_FRAME
  },
  {
    id: uuidv4(),
    title: 'Add color section',
    icon: <ColorsIcon />,
    type: 'colors',
    subMenu: [
      {
        id: uuidv4(),
        icon: <PrimaryColors />,
        title: 'Primary block',
        type: PRIMARY_COLORS
      },
      {
        id: uuidv4(),
        icon: <SecondaryColors />,
        title: 'Secondary block',
        type: SECONDARY_COLORS
      }
    ]
  }
];
